export const round = (value, decimals = 2) => {
  const multiplier = Math.pow(10, decimals);
  return Math.round(multiplier * value) / multiplier;
};

export const inEms = (sizeInPx, fontSize = 16) => round(sizeInPx / fontSize);
